import ApiClient from '../client';
import Config from '../../services/config.service';
const config = new Config();
const path = require('path');

class DatasetAPI extends ApiClient {

  datasetsRoles=undefined;

  datasetsGranularities=undefined;

  datasetsKinds=undefined;

  datasetsLicences=undefined;

  datasetsRecordTypes=undefined;

  datasetsRestrictions=undefined;

  datasetsTopics=undefined;

  datasetsUpdateFrequencies=undefined;

  datasetsCategories=undefined;

  constructor() {
    super();
  }

  async getDatasetsCount() {
    const route = path.join(
      this.DATASET_API_PATH,
      'datasets-count/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetsList(
    page = 1,
    usergroup,
    recordTypes,
    filters,
    controller
  ) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/?page_size=${config.itemsPerPage.datasets}&page=${page}`
    );
    if (usergroup) {
      route = route.concat('', `&usergroup_id=${usergroup}`);
    }
    if (recordTypes && recordTypes.length) {
      route = route.concat('', `&record_type=${recordTypes.join(',')}`);
    }
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter]}`);
    }
    const response = await this.get(
      route,
      { signal: controller.signal }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderDatasetsList(
    direction,
    field,
    page = 1,
    usergroup,
    recordTypes,
    filters,
    controller
  ) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/?page_size=${config.itemsPerPage.datasets}&ordering=${direction}${field}&page=${page}`
    );
    if (usergroup) {
      route = route.concat('', `&usergroup_id=${usergroup}`);
    }
    if (recordTypes && recordTypes.length) {
      route = route.concat('', `&record_type=${recordTypes.join(',')}`);
    }
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter]}`);
    }
    const response = await this.get(
      route,
      { signal: controller.signal }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDataset(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetScenarios(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetPermissions(id, filters, page = 1) {
    const route = path.join(
      this.DATASET_API_PATH,
      `usergroup-permissions/?dataset_id=${id}&page=${page}`
    );
    if (Object.values(filters).some(el => el && el.length > 0)) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length > 0) {
          route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderDatasetPermissions(direction, field, id, filters, page = 1) {
    let route = path.join(
      this.DATASET_API_PATH,
      `usergroup-permissions/?ordering=${direction}${field}&dataset_id=${id}&page=${page}`
    );
    if (Object.values(filters).some(el => el && el.length > 0)) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length > 0) {
          route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(
      route,
      
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async setDatasetPermissions(level, data) {
    const route = path.join(`${this.DATASET_API_PATH}`, `usergroup-permission-actions/?action=set_permission_level_${level}`);
    const response = await this.put(
      route,
      data,
      
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createDataset(data) {
    const route = path.join(
      this.DATASET_API_PATH,
      'datasets/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateDataset(id, data, scenarioId) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      if (scenarioId) await this.buildDatasetIndex(id, scenarioId);
      return response.data;
    }
    return false;
  }

  async buildDatasetIndex(id, scenarioId, asynchrone = true) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/_scenarios/${scenarioId}/run/?asynchrone=${asynchrone}`
    );
    const response = await this.post(route);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  async patchDataset(id, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async setDatasetThumbnail(id, data) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/thumbnail/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeDatasetThumbnail(id) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/thumbnail/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async deleteDataset(id) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return true;
    }
    return false;
  }

  async getDatasetsCategories() {
    if(this.datasetsCategories){
      return this.datasetsCategories;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'categories/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsCategories=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsGranularities() {
    if(this.datasetsGranularities){
      return this.datasetsGranularities;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'granularities/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsGranularities=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsLicences() {
    if(this.datasetsLicences){
      return this.datasetsLicences;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'licenses/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsLicences=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsTopics() {
    if(this.datasetsTopics){
      return this.datasetsTopics;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'topics/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsTopics=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsKinds() {
    if(this.datasetsKinds){
      return this.datasetsKinds;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'kinds/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsKinds=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRestrictions() {
    if(this.datasetsRestrictions){
      return this.datasetsRestrictions;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'restrictions/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRestrictions=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsUpdateFrequencies() {
    if(this.datasetsUpdateFrequencies){
      return this.datasetsUpdateFrequencies;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'update-frequencies/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsUpdateFrequencies=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRecordTypes() {
    if(this.datasetsRecordTypes){
      return this.datasetsRecordTypes;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'record-types/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRecordTypes=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRoles() {
    if(this.datasetsRoles){
      return this.datasetsRoles;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'contact-roles/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRoles=response.data;
      return response.data;
    }
    return false;
  }

  async getCurrentDatasetRoles(id) {
    try {
      const route = path.join(
        this.DATASET_API_PATH,
        `datasets/${id}/contact-roles/`
      );
      const response = await this.get(route);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  async createDatasetRole(datasetId, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/`
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateDatasetRole(datasetId, data, roleId, force = false) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/${roleId}/${force ? '?force=true' : ''}`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeDatasetRole(datasetId, roleId) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/${roleId}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async getContact(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getContacts(usergroupId, page) {
    let route = path.join(
      this.DATASET_API_PATH,
      'contacts/'
    );
    if (usergroupId) {
      route = route + `?usergroup_id=${usergroupId}`;
      if (page) {
        route = route + `&page=${page}`;
      }
    } else {
      if (page) {
        route = route + `?page=${page}`;
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createContact(data) {
    const route = path.join(
      this.DATASET_API_PATH,
      'contacts/'
    );
    const response = await this.post(route, data, );
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateContact(id, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeContact(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async getDatasetLogs(datasetId, page = 1) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/activity/?page=${page}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

}

const datasetAPI = new DatasetAPI();
export default datasetAPI;
